/* eslint-disable max-len */
import React from 'react';

import EmptyState from 'src/components/EmptyState';
import HttpLedger from 'src/components/HttpLedger';

import Label from 'src/components/Label';
import Card from 'src/components/Card';
import RelativeDate from 'src/components/RelativeDate';
import EngagementNameCell from 'src/components/cells/EngagementNameCell';
import RoleCell from 'src/components/cells/RoleCell';

function EngagementsForContactLedger({ contactId, accountId }: { contactId: string, accountId: string }) {
  const columns = [
    {
      title: 'Name',
      cellContent: (result: any) => <EngagementNameCell engagement={result} />,
    },
    {
      title: 'Role',
      cellContent: (result: any) => <RoleCell roleAssignments={result.roleAssignments} accountId={accountId} />,
    },
    {
      title: 'Current step',
      cellContent: (result: any) => <Label color="warning">{result.stepName}</Label>,
    },
    {
      title: 'Last activity',
      cellContent: (result: any) => <RelativeDate datetime={result.lastActivity} />,
    },
  ];

  return (
    <Card title="Assigned engagements" p={0}>
      <HttpLedger
        url={`/automatic/engagements-for-contact/${contactId}/`}
        columns={columns}
        emptyState={<EmptyState />}
        isPaginated
        isSearchable
      />
    </Card>
  );
}

export default EngagementsForContactLedger;
